(function () {
  const INIT_ATTR = "data-cpv-initialized";

  function normalize(s) {
    return String(s || "").trim().toLowerCase();
  }

  function isColorOptionName(name) {
    const n = normalize(name);
    return n === "color" || n === "colour" || n.includes("color");
  }

  function isSizeOptionName(name) {
    const n = normalize(name);
    return n === "size" || n.includes("size");
  }

  function init(scope = document) {
    const roots = scope.querySelectorAll
      ? scope.querySelectorAll("[data-cpv-root]")
      : [];

    roots.forEach((root) => {
      // If theme rerenders, the DOM node is new, so it won't have this attr yet.
      if (root.hasAttribute(INIT_ATTR)) return;

      const dataEl = root.querySelector("#CrossProductVariantsData");
      const mountEl = root.querySelector("[data-cross-product-variants]");
      if (!dataEl || !mountEl) return;

      let data;
      try {
        data = JSON.parse(dataEl.textContent);
      } catch (e) {
        console.warn("CPV: JSON parse failed", e);
        return;
      }

      const products = data.products || [];
      if (!products.length) return;

      // Prevent double-init for this DOM instance
      root.setAttribute(INIT_ATTR, "true");

      function findVariantByOptions(productObj, selectedOptions) {
        return productObj.variants.find((v) =>
          (v.options || []).every((opt, i) => opt === selectedOptions[i])
        );
      }

      function navigate(selectedOptions) {
        for (const p of products) {
          const v = findVariantByOptions(p, selectedOptions);
          if (v) {
            const url = new URL(p.url, window.location.origin);
            url.searchParams.set("variant", v.id);
            window.location.href = url.toString();
            return;
          }
        }
      }

      function buildMatrix() {
        const optionNames = products[0].options || [];
        const values = optionNames.map(() => new Set());

        products.forEach((p) => {
          (p.variants || []).forEach((v) => {
            (v.options || []).forEach((opt, i) => values[i]?.add(opt));
          });
        });

        return {
          optionNames,
          optionValues: values.map((set) => [...set]),
        };
      }

      function getThumbForColor(val, colorIdx) {
        for (const p of products) {
          const v = (p.variants || []).find((vv) => vv.options?.[colorIdx] === val);
          if (v) return v.image || p.featuredImage;
        }
        return null;
      }

      function renderSelect(label, values, selected, onChange) {
        const wrap = document.createElement("div");
        wrap.className = "cpv-option";

        const lab = document.createElement("label");
        lab.textContent = label;
        wrap.appendChild(lab);

        const sel = document.createElement("select");
        values.forEach((v) => {
          const opt = document.createElement("option");
          opt.value = v;
          opt.textContent = v;
          if (v === selected) opt.selected = true;
          sel.appendChild(opt);
        });

        sel.addEventListener("change", (e) => onChange(e.target.value));
        wrap.appendChild(sel);

        return wrap;
      }

      function renderThumbs(label, values, selected, onPick, colorIdx) {
        const wrap = document.createElement("div");
        wrap.className = "cpv-option";

        const title = document.createElement("div");
        title.className = "cpv-label";
        title.textContent = label;
        wrap.appendChild(title);

        const grid = document.createElement("div");
        grid.className = "cpv-thumbs";

        values.forEach((val) => {
          const btn = document.createElement("button");
          btn.type = "button";
          btn.className = "cpv-thumb";
          btn.setAttribute("aria-label", val);
          btn.setAttribute("aria-pressed", val === selected ? "true" : "false");

          const imgUrl = getThumbForColor(val, colorIdx);
          if (imgUrl) {
            const img = document.createElement("img");
            img.src = imgUrl;
            img.alt = val;
            img.loading = "lazy";
            btn.appendChild(img);
          } else {
            // fallback if no image
            btn.textContent = val;
          }

          btn.addEventListener("click", () => onPick(val));
          grid.appendChild(btn);
        });

        wrap.appendChild(grid);
        return wrap;
      }

	function renderSizeBlocks(label, values, selected, onPick, optionIdx, selectedOptions, currentProduct) {
	  const wrap = document.createElement("div");
	  wrap.className = "cpv-option";
	
	  const title = document.createElement("div");
	  title.className = "cpv-label";
	  title.textContent = label;
	  wrap.appendChild(title);
	
	  const grid = document.createElement("div");
	  grid.className = "cpv-size-grid";
	
	  values.forEach((val) => {
		const btn = document.createElement("button");
		btn.type = "button";
		btn.className = "cpv-size-btn";
		btn.textContent = val;
		btn.setAttribute("aria-pressed", val === selected ? "true" : "false");
	
		const trialOptions = [...selectedOptions];
		trialOptions[optionIdx] = val;
	
		const matchedVariant = findVariantByOptions(currentProduct, trialOptions);
	
		if (!matchedVariant) {
		  // Shouldn’t really happen anymore, but safe fallback
		  btn.classList.add("cpv-size-btn--unavailable");
		  btn.disabled = true;
		  btn.setAttribute("aria-disabled", "true");
		} else {
		  if (!matchedVariant.available) {
			btn.classList.add("cpv-size-btn--sold-out");
			btn.setAttribute("data-sold-out", "true");
		  }
	
		  // ALWAYS clickable (for back-in-stock flows)
		  btn.addEventListener("click", () => onPick(val));
		}
	
		grid.appendChild(btn);
	  });
	
	  wrap.appendChild(grid);
	  return wrap;
	}

      // Initial selection: match current URL variant if possible, else first variant
      const currentProduct =
        products.find((p) => p.handle === data.currentProductHandle) || products[0];

      const url = new URL(window.location.href);
      const urlVariantId = url.searchParams.get("variant");
      const urlVariant = urlVariantId
        ? currentProduct.variants.find((v) => String(v.id) === String(urlVariantId))
        : null;

      const defaultVariant = urlVariant || currentProduct.variants[0];
      const selectedOptions = [...(defaultVariant?.options || [])];

      const { optionNames, optionValues } = buildMatrix();

      mountEl.innerHTML = "";

      optionNames.forEach((name, idx) => {
        
        let values = [];
		if (isSizeOptionName(name)) {
		  // Only pull sizes from current product
		  const sizeSet = new Set();
		
		  currentProduct.variants.forEach((v) => {
			const val = v.options?.[idx];
			if (val) sizeSet.add(val);
		  });
		
		  values = [...sizeSet];
		} else {
		  values = optionValues[idx] || [];
		}
        
        
        const selected = selectedOptions[idx] || values[0];

        const onChange = (val) => {
          selectedOptions[idx] = val;
          navigate(selectedOptions);
        };

        if (isColorOptionName(name)) {
          mountEl.appendChild(renderThumbs(name, values, selected, onChange, idx));
          return;
        }

        if (isSizeOptionName(name)) {
			mountEl.appendChild(
			  renderSizeBlocks(name, values, selected, onChange, idx, selectedOptions, currentProduct)
			);          
			return;
        }

        mountEl.appendChild(renderSelect(name, values, selected, onChange));
      });
    });
  }

  document.addEventListener("DOMContentLoaded", () => init(document));
  document.addEventListener("shopify:section:load", (e) => init(e.target));

  // Rerender safety for themes that swap product DOM
  new MutationObserver((muts) => {
    muts.forEach((m) => {
      m.addedNodes.forEach((n) => {
        if (n.nodeType === 1) init(n);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();